import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { type IProductDataV3 } from '@df/catalog/product/product';
import { UiComponent } from '@df/ui/ui.component';
import { Product } from '../../product.decorator';

export const WARRANTY_AND_RETURNS_MODAL_ID = 'warrantyAndReturnsModal';

@Component({
    selector: 'product-view-warranty-and-returns-modal',
    templateUrl: './product-view-warranty-and-returns-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class WarrantyAndReturnsModalComponent extends UiComponent {
    readonly product = input.required<Product<IProductDataV3>>();
}
